import EditJobModal from 'components/V2/EditJobModal';
import moment from 'moment-timezone';
import React, { Component } from 'react';
import ExperienceModal from 'scenes/Dashboard/V2/ExperienceModal/ExperienceModal';
import { approveAthleticTrainer, decline, removeJob } from 'redux/ducks/Job';
import { getAthleticTrainer } from 'redux/ducks/User';
import { connect } from 'react-redux';
import { getTimezone } from 'helpers/post';
import ConfirmationModal from 'components/V2/ConfirmationModal';
import classNames from 'classnames';
import { hasToVerifyMicroDeposits } from '../../../../helpers/payment';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

const STATUS_PANEL = {
  pending: {
    name: 'APPLIED',
    statusColor: 'black',
  },
  eo_accepted_at: {
    name: 'PENDING CONFIRMATION',
    statusColor: 'black',
  },
  confirmed: {
    name: 'CONFIRMED',
    statusColor: 'teal',
  },
  checked_in: {
    name: 'CHECKED IN',
    statusColor: 'teal',
  },
  waitlist: {
    name: 'WAITLIST',
    statusColor: 'black',
  },
  callout: {
    name: 'CALLOUT',
    statusColor: 'grey',
  },
  decommitted: {
    name: 'CALLOUT',
    statusColor: 'grey',
  },
  paid: {
    name: 'PAID',
    statusColor: 'black',
  },
};

const DISPLAY_BUTTONS = {
  pending: ['accept', 'decline'],
  eo_accepted_at: ['remove'],
  confirmed: ['edit', 'remove'],
  checked_in: ['edit'],
  waitlist: ['remove'],
  callout: [],
  paid: [],
  decommitted: [],
};

const MAP_BUTTON_NAME = {
  accept: {
    buttonText: 'ACCEPT',
    color: 'teal',
  },
  decline: {
    buttonText: 'DECLINE',
    color: 'grey',
  },
  edit: {
    buttonText: 'EDIT JOB',
    color: 'teal',
  },
  remove: {
    buttonText: 'REMOVE',
    color: 'grey',
  },
};

export const getStateStatus = (state) => {
  return STATUS_PANEL[state];
};

class JobActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openEditJob: false,
      openDeclineModal: false,
      openRemoveModal: false,
      verifyPaymentModal: false,
    };
  }

  toggleEditJob = () => {
    this.setState((prevState) => ({
      ...prevState,
      openEditJob: !this.state.openEditJob,
    }));
  };

  toggleVerifyPaymentModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      verifyPaymentModal: !this.state.verifyPaymentModal,
    }));
  };

  toggleDeclineModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      openDeclineModal: !this.state.openDeclineModal,
    }));
  };

  toggleRemoveModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      openRemoveModal: !this.state.openRemoveModal,
    }));
  };

  onApprove = (job) => {
    this.props.approveTrainer(job);
  };

  onDecline = (id) => {
    this.props.decline(id);
  };

  onRemove = (id) => {
    this.props.remove(id);
  };

  buttonAction = (button) => () => {
    const { job, payment } = this.props;

    switch (button) {
      case 'accept':
        if (hasToVerifyMicroDeposits(payment) && !get(payment, 'source.id')) {
          this.toggleVerifyPaymentModal();
          break;
        }

        this.onApprove(job);
        break;
      case 'decline':
        this.toggleDeclineModal();
        break;
      case 'edit':
        this.toggleEditJob();
        break;
      case 'remove':
        this.toggleRemoveModal();
        break;
      default:
        break;
    }
  };

  getAtTById = (ATId) => {
    const { pendingApplicants } = this.props;
    const ATIndex = pendingApplicants.findIndex((at) => at.id === ATId);

    if (ATIndex !== -1) return;

    this.props.getAthleticTrainer(ATId);
  };

  goToVerifyPayment = () => {
    this.props.history.push('/edit-payment');
  };

  render() {
    const { job, pendingApplicants, shift } = this.props;
    const { user } = job;
    const buttons = DISPLAY_BUTTONS[job.currentState];
    const tz = getTimezone(shift.eventLocation);
    const notPassedShift = moment(shift.endTime).isAfter(moment());
    const canModifyJob = moment(job.endTime).add(12, 'hours').isAfter(moment());

    return (
      <React.Fragment>
        <div className={classNames('button-cell')}>
          <ExperienceModal
            onClick={() => this.getAtTById(user.id)}
            onApprove={() => this.onApprove(job)}
            onDecline={() => this.onDecline(job.id)}
            onRemove={() => this.onRemove(job.id)}
            id={user.id}
            pendingApplicants={pendingApplicants}
            from={this.props.from}
            canDoAction={job.currentState === 'pending'}
            job={job}
          >
            VIEW PROFILE
          </ExperienceModal>
        </div>
        <div className={classNames('button-cell')}>
          {buttons.includes('accept') && notPassedShift && (
            <button
              key={`key-button-accept`}
              className={`plain-button action-button ${MAP_BUTTON_NAME['accept'].color}`}
              onClick={this.buttonAction('accept')}
            >
              {MAP_BUTTON_NAME['accept'].buttonText}
            </button>
          )}
        </div>
        <div className={classNames('button-cell')}>
          {buttons.includes('edit') && canModifyJob && (
            <EditJobModal
              {...this.props}
              key={job.id}
              job={job}
              tz={tz}
              user={user}
              isOpen={this.state.openEditJob}
              toggleEditJob={this.toggleEditJob}
              childTextColor={MAP_BUTTON_NAME['accept'].color}
              location={shift.eventLocation}
            >
              <span onClick={this.props.onEdit}>{MAP_BUTTON_NAME['edit'].buttonText}</span>
            </EditJobModal>
          )}
        </div>
        <div className={classNames('button-cell')}>
          {buttons.includes('decline') && notPassedShift && (
            <button
              key={`key-button-decline`}
              className={`plain-button action-button ${MAP_BUTTON_NAME['decline'].color}`}
              onClick={this.buttonAction('decline')}
            >
              {MAP_BUTTON_NAME['decline'].buttonText}
            </button>
          )}
          {buttons.includes('remove') && notPassedShift && (
            <button
              key={`key-button-remove`}
              className={`plain-button action-button ${MAP_BUTTON_NAME['remove'].color}`}
              onClick={this.buttonAction('remove')}
            >
              {MAP_BUTTON_NAME['remove'].buttonText}
            </button>
          )}
        </div>
        <ConfirmationModal
          isOpen={this.state.openDeclineModal}
          toggle={this.toggleDeclineModal}
          title="Decline Application"
          body={`Are you sure you want to decline this application from ${user.firstName} ${user.lastName}?`}
          onSave={() => this.onDecline(job.id)}
          cancelText="Go Back"
          confirmText="Decline"
          onCancel={this.toggleDeclineModal}
        />
        <ConfirmationModal
          isOpen={this.state.openRemoveModal}
          toggle={this.toggleRemoveModal}
          title="Remove Application"
          body={`Are you sure you want to remove this application from ${user.firstName} ${user.lastName}?`}
          onSave={() => this.onRemove(job.id)}
          cancelText="Go Back"
          confirmText="Remove"
          onCancel={this.toggleRemoveModal}
        />
        <ConfirmationModal
          isOpen={this.state.verifyPaymentModal}
          toggle={this.toggleVerifyPaymentModal}
          title="Verify Payment Source"
          body={`You must verify your bank account with micro deposits before accepting applicants.`}
          onSave={this.goToVerifyPayment}
          cancelText="Cancel"
          confirmText="Verify"
          onCancel={this.toggleVerifyPaymentModal}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  payment: state.payment,
});

const mapDispatchToProps = (dispatch) => ({
  approveTrainer: (job) => dispatch(approveAthleticTrainer(job)),
  decline: (id) => dispatch(decline(id)),
  remove: (id) => dispatch(removeJob(id)),
  getAthleticTrainer: (id) => dispatch(getAthleticTrainer(id)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobActions));
